import React from 'react';
import moment from 'moment';
import PanelExportButton from './PanelExportButton.jsx';
import PanelIDSExportButton from './PanelIDSExportButton.jsx';

var GoogleMapsLoader = require('google-maps');
var MarkerCluster = require('@google/markerclusterer');
import m1 from '../../images/clustermarker/m1.png';
import m2 from '../../images/clustermarker/m2.png';
import m3 from '../../images/clustermarker/m3.png';
import m4 from '../../images/clustermarker/m4.png';
import m5 from '../../images/clustermarker/m5.png';

export default class PanelMap extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
        this.renderMap();
    }

    componentDidUpdate() {
        this.renderMap();
    }

    renderMap() {
        const self = this;
        GoogleMapsLoader.KEY = "AIzaSyCBZpaGoUvXlsgS93QmUNdw0rjT1eEyrT4";
        GoogleMapsLoader.VERSION = 'quarterly';
        GoogleMapsLoader.load(function (google) {
            const map = new google.maps.Map(document.getElementById("panel_map_container_" + self.props.campaignType), {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                streetViewControl: false,
                mapTypeControlOptions: {
                    mapTypeIds: [] //can't switch from roadmap
                },
                scrollwheel: false
            });

            const infoWindow = new google.maps.InfoWindow({});
            google.maps.event.addListener(map, 'click', function () {
                infoWindow.close();
            });
            const showInfoWindow = function (marker, panel) {
                let incidents = "";
                if (panel.incidents) {
                    for (let i = 0; i < panel.incidents.length; i++) {
                        incidents += `<div><br/><b>${moment(panel.incidents[i].periodStart).format('YYYY-MM-DD')} - ${moment(panel.incidents[i].periodEnd).format('YYYY-MM-DD')}:</b><br/>${panel.incidents[i].note}</div>`;
                    }
                }
                let panelIds = "";
                if (panel.panelIdsAtLocation) {
                    for (let i = 0; i < panel.panelIdsAtLocation.length; i++) {
                        panelIds += "<div><b>Panel-id: </b>" + panel.panelIdsAtLocation[i] + "   <b>Status: </b>" + panel.status + "</div>";
                    }
                }
                let address = panel.address !== null ? panel.address : ""
                const markerContent = "<div class=\"infoWindowContent\">" +
                    panelIds +
                    "<div><b>Address: </b>" + address + " " + panel.city + "</div>" +
                    incidents +
                    "</div>";
                return function () {
                    infoWindow.setContent(markerContent);
                    infoWindow.open(map, marker);
                }
            };
            let markers = [];
            let markerClusterOptions = {
                styles: [
                    {
                        height: 53,
                        url: m1,
                        width: 53
                    },
                    {
                        height: 56,
                        url: m2,
                        width: 56
                    },
                    {
                        height: 66,
                        url: m3,
                        width: 66
                    },
                    {
                        height: 78,
                        url: m4,
                        width: 78
                    },
                    {
                        height: 90,
                        url: m5,
                        width: 90
                    }
                ],
                minimumClusterSize: 25
            };
            let markerCluster = new MarkerCluster(map, markers,markerClusterOptions);
            const bounds = new google.maps.LatLngBounds();
            //console.log('add markers ', self.props.panels.length);
            for (let i = 0; i < self.props.panels.length; i++) {
                //console.log('add marker for ', i, self.props.panels[i]);
                setTimeout(() => {
                    try {
                        if (!self.props.panels[i].latitude || !self.props.panels[i].longitude) {
                            //console.log('return at ', i, self.props.panels[i]);
                            if (i === self.props.panels.length - 1) {
                                //console.log('fit and center', i);
                                self.fitAndCenter(map, bounds);
                            }
                            return;
                        }
                        let panelColor = self.props.panels[i].color !== null
                            ? self.props.panels[i].color
                            : "#72BF44"; //deafult to the old std green value
                        let marker = new google.maps.Marker({
                            map: map,
                            position: { lat: self.props.panels[i].latitude, lng: self.props.panels[i].longitude },
                            icon: {
                                path: google.maps.SymbolPath.CIRCLE,
                                scale: 5,
                                strokeWeight: 1,
                                fillOpacity: 1,
                                fillColor: panelColor,
                                strokeColoe: "#000000"
                            }
                        });
                        //console.log('marker ', i, marker);
                        google.maps.event.addListener(marker, "click", showInfoWindow(marker, self.props.panels[i]));
                        bounds.extend(marker.position);
                        markerCluster.addMarker(marker);

                        //fit and center map when all merkers are added
                        if (i === self.props.panels.length - 1) {
                            //console.log('fit and center', i);
                            self.fitAndCenter(map, bounds);
                        }
                    } catch (err) {
                        // console.log('error ', err);
                    }
                }, 2);
            }
        });
    }

    fitAndCenter(map, bounds) {
        //console.log('fit and center', this.props.parameters.zoomFactor);
        map.fitBounds(bounds);
        map.setCenter(map.getCenter());
        let zoomFactor = this.props.campaignType === 'posting'
            ? this.props.parameters.zoomFactorPosting
            : this.props.parameters.zoomFactorPlay;
        let self = this;
        setTimeout(function () {
            map.setZoom(map.getZoom() > 15 ? 15 : map.getZoom() + zoomFactor);
        }, 100);
    }

    render() {
        return (
            <div className="row">
                <div className="col-md-12">
                    <h4>{this.props.header}</h4>
                </div>
                <div className="col-md-12">
                    <div id={'panel_map_container_' + this.props.campaignType}></div>
                </div>

                {this.props.campaignType === 'posting' &&
                    <div >
                        <div >
                            <div className="col-md-2">
                                <div className="panel-legend">
                                    <span className="dot green-dot"></span>
                                    <span >Posted</span>

                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="panel-legend">
                                    <span className="dot blue-dot"></span>
                                    <span >Failed</span>

                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="panel-legend">
                                    <span className="dot yellow-dot"></span>
                                    <span >Ongoing</span>

                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="panel-legend">
                                    <span className="dot orange-dot"></span>
                                    <span >Not Started</span>

                                </div>
                            </div>


                            <div className="col-md-3" style={{ position: 'relative', right: '23px' }} align="right">
                                <PanelExportButton
                                    panels={this.props.panels}
                                    campaignType={this.props.campaignType}
                                    campaignName={this.props.campaignName}
                                    allowAddressExport={this.props.allowAddressExport}
                                    packageType={this.props.packageType}
                                    exportPanelSOVValue={this.props.parameters.clientSettings.exportPanelSOVValue}
                                />

                                {this.props.showPostingExportIDS !== 'Hide' &&
                                    <PanelIDSExportButton
                                        panels={this.props.panels}
                                        campaignType={this.props.campaignType}
                                        campaignName={this.props.campaignName}
                                        exportAllowed={this.props.showPostingExportIDS}
                                        periodStart={this.props.campaignInfo.periodStart}
                                        newSOVCalculationFrom={this.props.parameters.clientSettings.newSOVCalculationFrom}
                                        style={{ marginTop: '2px', width: '140px' }}
                                    />
                                }
                            </div>
                        </div>
                        <div className="col-md-12" align="right" style={{ marginTop: '2px' }}></div>

                        {!this.props.allowAddressExport &&
                            <div className="row posting-export-text" style={{ paddingLeft: '30px' }}>
                                Please note that the address list for this network is available {this.props.parameters.daysToStartAdressExport} work days before campaign start
                            </div>
                        }
                    </div>
                }
                {this.props.campaignType === 'play' && this.props.showPanelExport &&
                    <div className="col-md-12" align="right">
                        <PanelExportButton
                            panels={this.props.panels}
                            campaignType={this.props.campaignType}
                            campaignName={this.props.campaignName}
                            allowAddressExport={this.props.allowAddressExport}
                            exportPanelSOVValue={this.props.parameters.clientSettings.exportPanelSOVValue}/>
                    </div>
                }
            </div>

        );
    }
}